import React from 'react';
import { TagContext } from 'tags/context/tagContext';
import { CARD_TYPE } from 'tags/models/schemas';
import {
  assignTagsToSimProducts,
  createSimProductsTag,
  fetchAssignedTagToSimProduct,
  fetchSimProductsTag,
  fetchSimProductsTags,
} from './services/tagsSimProductApi';

type TagProviderProps = {
  children: React.ReactNode;
};

const SIM_PRODUCT_TAGS_CONTENT_API = {
  assignTags: assignTagsToSimProducts,
  fetchTag: fetchSimProductsTag,
  fetchAssignedTags: fetchAssignedTagToSimProduct,
  createTag: createSimProductsTag,
  fetchTags: fetchSimProductsTags,
  type: CARD_TYPE.SIM,
  isProduct: true,
};

export const SimProductTagProvider = ({ children }: TagProviderProps) => {
  return <TagContext.Provider value={SIM_PRODUCT_TAGS_CONTENT_API}>{children}</TagContext.Provider>;
};
